import React from 'react';

import classNames from './EABDBackButton.module.scss';

export interface BackButtonProps
  extends Readonly<{
    text: string;
    onPress: () => void;
  }> {}

export const BackButton = React.memo<BackButtonProps>((props) => {
  const { text, onPress } = props;

  return (
    <button onClick={onPress} type={'button'} className={classNames.button}>
      <div className={classNames.arrow} />
      <p className={classNames.text}>{text}</p>
    </button>
  );
});
